// extracted by mini-css-extract-plugin
export default {"LogsFilters":"Y9rD9I3dksp2E4iUYI0m","Item":"JhAOvn7Q1m_b6RNfHTX2","DeleteBtn":"qpLKZ2dbpsE5lRQYQFOw"};